// Meta Pixel Hook for tracking events
declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

const PIXEL_ID = '904375051696707'

// Initialize Meta Pixel
export function initMetaPixel() {
  if (typeof window === 'undefined') return

  // Check if already initialized
  if (window.fbq && window.fbq.loaded) return

  // Create fbq function
  const fbq: any = (window.fbq = function () {
    fbq.callMethod
      ? fbq.callMethod.apply(fbq, arguments)
      : fbq.queue.push(arguments)
  })

  if (!window._fbq) window._fbq = fbq
  fbq.push = fbq
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.queue = []

  // Load the Facebook SDK script
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'

  // Insert script at the beginning of head
  const firstScript = document.getElementsByTagName('script')[0]
  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript)
  } else {
    document.head.appendChild(script)
  }

  // Add noscript pixel image for fallback
  const noscriptImg = document.createElement('img')
  noscriptImg.height = 1
  noscriptImg.width = 1
  noscriptImg.style.display = 'none'
  noscriptImg.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
  document.body.appendChild(noscriptImg)

  // Initialize pixel
  window.fbq('init', PIXEL_ID)

  // Track PageView immediately after init
  window.fbq('track', 'PageView')

  console.log('Meta Pixel initialized with ID:', PIXEL_ID)
}

// Track PageView
export function trackPageView() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView')
    console.log('Meta Pixel: PageView tracked')
  }
}

// Track AddToCart
export function trackAddToCart(
  contentName?: string,
  value?: number,
  currency?: string,
) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: contentName || 'Cuidador Sin Caos',
      content_type: 'product',
      value: value || 9300,
      currency: currency || 'ARS',
    })
    console.log('Meta Pixel: AddToCart tracked')
  }
}

// Track Purchase (for future use)
export function trackPurchase(value?: number, currency?: string) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'Purchase', {
      value: value || 9300,
      currency: currency || 'ARS',
    })
    console.log('Meta Pixel: Purchase tracked')
  }
}

// Track InitiateCheckout (for future use)
export function trackInitiateCheckout(value?: number, currency?: string) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'InitiateCheckout', {
      value: value || 9300,
      currency: currency || 'ARS',
    })
    console.log('Meta Pixel: InitiateCheckout tracked')
  }
}
